<script>
	import { Tooltip } from "bits-ui";
  import { cn } from "@lib/utils";

  let { hint, children, triggerChild, delay = 200, side = "bottom", class: className } = $props()
  
</script>
 
{#if hint}

  <Tooltip.Provider delayDuration={delay} ignoreNonKeyboardFocus>
    <Tooltip.Root class="contents">
      <Tooltip.Trigger>
        {#snippet child({ props })}
          {#if triggerChild}
            {@render triggerChild?.({ props })}
          {:else}
            <span {...props} class="inline-flex items-center align-middle">{@render children?.()}</span>
          {/if}
        {/snippet}
      </Tooltip.Trigger>
      <Tooltip.Portal>
        <Tooltip.Content
          {side}
          sideOffset={6}
          class={cn("z-50 text-[11px] bg-black text-white rounded-sm px-2 py-1 shadow-sm", className)}
        >
          <Tooltip.Arrow class="fill-black" />
          {hint}
        </Tooltip.Content>
      </Tooltip.Portal>
    </Tooltip.Root>
  </Tooltip.Provider>

{:else}
  {@render children?.()}
{/if}